import React from 'react';
export function SuccessStories() {
  const timeline = [{
    days: '3-7 TAGE',
    icon: '💧',
    results: ['Erste spürbare Veränderungen', 'Mehr Energie am Morgen', 'Weniger Heißhunger-Attacken', 'Bessere Verdauung, weniger Völlegefühl'],
    quote: 'Am 5. Tag habe ich es gespürt – plötzlich hatte ich morgens richtig Power!',
    author: 'Sarah T.'
  }, {
    days: '14 TAGE',
    icon: '✨',
    results: ['SICHTBARE Ergebnisse beginnen', 'Muskeln wirken definierter', 'Haut strahlt mehr', '87% berichten: "Ich sehe den Unterschied!"'],
    quote: 'Nach 2 Wochen fragten mich Kollegen, ob ich abgenommen hätte. Dabei hatte ich nur 1kg verloren – aber mein Körper sah einfach straffer aus!',
    author: 'Bärbel R., 62'
  }, {
    days: '4-8 WOCHEN',
    icon: '💪',
    results: ['Deutlich sichtbare Transformation', '+7,5% Muskelmasse messbar', 'Durchschnittlich -1,8kg Körperfett', 'Kleidung sitzt besser'],
    quote: 'In Woche 6 musste ich meine Jeans eine Nummer kleiner kaufen. Meine Arme sind straffer, mein Bauch flacher – ich fühle mich wie mit 35!',
    author: 'Katrin B., 47'
  }, {
    days: '12 WOCHEN',
    icon: '🌟',
    results: ['Dramatische Transformation', '+20,2% Muskeldicke (klinisch gemessen)', '+8,8% mehr Kraft', '92% sagen: "Beste Investition meines Lebens"'],
    quote: 'Ich wünschte, ich hätte früher angefangen. Ich bin 54 und fühle mich wie 40.',
    author: 'Martina S., 54'
  }];
  return <section className="py-16 bg-gradient-to-b from-emerald-50 to-white" data-id="element-281">
      <div className="max-w-4xl mx-auto" data-id="element-282">
        <div className="text-center mb-12" data-id="element-283">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-medium py-1 px-3 rounded-full mb-3" data-id="element-284">
            Timeline der Ergebnisse
          </span>
          <h3 className="text-4xl font-bold text-gray-800 mb-4" data-id="element-285">
            Was Sie erwarten können
          </h3>
          <p className="text-gray-600" data-id="element-286">
            Basierend auf 1.247 echten Kundenbewertungen
          </p>
        </div>
        <div className="space-y-8" data-id="element-287">
          {timeline.map((phase, index) => <div key={index} className="bg-white rounded-xl p-8 border-2 border-emerald-200 shadow-lg" data-id="element-288">
              <div className="flex items-center mb-6" data-id="element-289">
                <div className="text-4xl mr-4" data-id="element-290">{phase.icon}</div>
                <div data-id="element-291">
                  <h4 className="text-2xl font-bold text-emerald-700" data-id="element-292">
                    NACH {phase.days}
                  </h4>
                </div>
              </div>
              <ul className="space-y-3 mb-6" data-id="element-293">
                {phase.results.map((result, idx) => <li key={idx} className="flex items-start" data-id="element-294">
                    <span className="text-emerald-600 mr-2" data-id="element-295">•</span>
                    <span className="text-gray-700 font-medium" data-id="element-296">{result}</span>
                  </li>)}
              </ul>
              <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-100" data-id="element-297">
                <p className="text-gray-700 italic mb-2" data-id="element-298">"{phase.quote}"</p>
                <p className="text-sm text-emerald-700 font-semibold" data-id="element-299">
                  - {phase.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}